import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AlternativeStepperComponent,
  IStep,
} from '../../../../components/ui/alternative-stepper/alternative-stepper.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { ColumnMappingComponent } from './column-mapping/column-mapping.component';
import { CleanUpComponent } from './clean-up/clean-up.component';
import { ReviewComponent } from './review/review.component';
import { FeedbackComponent } from './feedback/feedback.component';

const STEP_COPY: Record<string, string> = {
  upload: 'Bring in a CSV or Excel file. You can check and fix every row before anything is saved.',
  mapping: 'Tell us which column in your file holds each contact field.',
  cleanup: 'Fix or remove the rows that will not import. Nothing is saved yet.',
  review: 'Add organizations or tags, then add the contacts.',
  feedback: 'What was added, what was skipped and what failed.',
};

@Component({
  selector: 'app-csv',
  standalone: true,
  imports: [
    AlternativeStepperComponent,
    UploadFileComponent,
    ColumnMappingComponent,
    CleanUpComponent,
    ReviewComponent,
    FeedbackComponent,
  ],
  templateUrl: './csv.component.html',
  styleUrl: './csv.component.css',
})
export class CsvComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  searchQuery!: string;

  get description(): string {
    return STEP_COPY[this.searchQuery] ?? STEP_COPY['upload'];
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.searchQuery = params['title'];
    });
  }

  backToContacts() {
    this.router.navigate(['/organization/contacts']);
  }

  steps: IStep[] = [
    { stepName: 'Upload file', stepQuery: 'upload' },
    { stepName: 'Match columns', stepQuery: 'mapping' },
    { stepName: 'Clean up', stepQuery: 'cleanup' },
    { stepName: 'Review', stepQuery: 'review' },
    { stepName: 'Result', stepQuery: 'feedback' },
  ];
}
